<template>
  <span v-if="label" class="point-capacity-tag" :class="{ 'is-warning': !isConfigured }">{{ label }}</span>
</template>

<script>
import { getPointCapacityLabel, isPointCapacityConfigured } from '@/utils/puntoScharffCapacity'

export default {
  props: {
    point: { required: false, default: null },
  },
  computed: {
    label() {
      return getPointCapacityLabel(this.point)
    },
    // A point without configured capacity blocks the quote, so it is the only state worth alerting.
    isConfigured() {
      return isPointCapacityConfigured(this.point)
    },
  },
}
</script>

<style lang="scss" scoped>
.point-capacity-tag {
  display: inline-block;
  align-self: flex-start;
  width: fit-content;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  white-space: nowrap;
  background: rgba(212, 82, 255, 0.15);
  color: #490050;

  &.is-warning {
    background: rgba(178, 0, 0, 0.1);
    color: #B20000;
  }
}
</style>
